import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

export interface TileOption {
    text: string;
    value: number;
    id: string;
}

export interface TileQuestion {
    question: string;
    description: string;
}

@Component({
    selector: 'app-tile-question',
    templateUrl: './tile-question.component.html',
    styleUrls: ['./tile-question.component.scss'],
})
export class TileQuestionComponent implements OnInit {
    @Input() question: TileQuestion;
    @Input() options: TileOption[];

    @Output() changeOption = new EventEmitter<TileOption>();

    selectedOption: TileOption = {} as TileOption;

    selectOption(option) {
        this.selectedOption = option;
        this.changeOption.emit(option);
    }

    newOptionId(optionId) {}

    constructor() {}

    ngOnInit() {
        this.newOptionId(Option);
    }
}
